import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'form-wrapper',
	templateUrl: './form-wrapper.component.html',
	styleUrls: ['./form-wrapper.component.less']
	//encapsulation: ViewEncapsulation.None
})
export class FormWrapperComponent {

	@Input() header?: string;

}
